import classNames from "classnames"
import React from "react";
import { root, title, field, contents, footer, item, label, required } from "./formbox.module.scss";

interface Props {
  className?: string
  id?: string
  required?: boolean
  children: React.ReactNode
}

interface LabelProps {
  className?: string
  required?: boolean
}

const Root = React.memo((props: Props) => {
  const { id, children } = props

  return (
    <div id={id} className={root}>
      {children}
    </div>
  )
});

const Title = React.memo((props: Props) => {
  const { children } = props

  return (
    <div className={title}>{children}</div>
  )
});

const Field = React.memo((props: Props) => {
  const { children } = props
  return (
    <div className={field}>{children}</div>
  )
});

const Contents = React.memo((props: Props) => {
  const { children } = props
  return (
    <div className={contents}>{children}</div>
  )
});

const Footer = React.memo((props: Props) => {
  const { children } = props
  return (
    <div className={footer}>{children}</div>
  )
});

const Item = React.memo((props: Props) => {
  const { children } = props

  return (
    <div className={item}>{children}</div>
  )
})

const Label = React.memo((props: LabelProps) => {
  const { className, required: requiredValue } = props
  const classes = classNames(
    label,
    {
      [required]: requiredValue,
    },
    className
  )

  if (!required) {
    return (
      <div className={classes}>任意</div>
    )
  } else {
    return (
      <div className={classes}>必須</div>
    )
  }
});

export default Object.assign(Root, {Title, Contents, Label, Footer, Field, Item})
